export const COOKIE_POLICY_URL = 'https://raceroster.com/legal/cookie-statement';
export const GTM_CONTAINER_ID = 'GTM-T7T88D8';
